import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function SiteIntroBand() {
  return (
    <section className="bg-primary-900 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-10 px-4 md:px-8 lg:grid-cols-2">
        <div>
          <span className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
            ABOUT THE SITE
          </span>
          <h2 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-3xl">
            关于疯狂试爱2影视内容站
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">{siteInfo.intro}</p>

          <div className="mt-8 grid grid-cols-2 gap-6 sm:grid-cols-4">
            {siteInfo.stats.map((stat) => (
              <div key={stat.label}>
                <p className="font-heading text-2xl font-bold text-accent-400">{stat.value}</p>
                <p className="mt-1 text-xs text-primary-200">{stat.label}</p>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            了解我们更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="relative h-64 w-full overflow-hidden rounded-lg md:h-80">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20empty%20modern%20cinema%20auditorium%20with%20deep%20blue%20ambient%20lighting%20and%20warm%20orange%20accent%20seats%2C%20atmospheric%20moody%20lounge%2C%20soft%20haze%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail%2C%2035mm%20cinematic%20look&width=1000&height=700&seq=fsa2-about&orientation=landscape"
            alt="疯狂试爱2 影视内容站"
            className="h-full w-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}